import { gql } from "@/services/httpAdapter";

const CancellationsFragment = gql`
	fragment Cancellations on WashoutCancellation {
		_id
		dlcd
		product
		trntype
		amtDueWtyCo
		lastName
		firstName
		cancelAmount
		stockNumber
		dealNumber
		chargeBackGross
		saleDate
		cancellationDate
	}
`;

const SalesLogTotalFragment = gql`
	fragment SalesLogTotal on WashoutSalesLogTotal {
		frontGrossProfit
		backGrossProfit
		units
		backProducts {
			_id
			product
			total
		}
	}
`;

const SalesLogRowFragment = gql`
	fragment SalesLogRow on WashoutSalesLogRow {
		_id
		saleDate
		dealNumber
		dealStatus
		customerName
		salesAssociateName
		financeManagerName
		dealManagerName
		stockNumber
		saleType
		frontGrossProfit
		backGrossProfit
		units
		backProducts {
			_id
			product
			value
		}
	}
`;

const SalesLogFragment = gql`
	fragment SalesLog on WashoutSalesLog {
		sales {
			...SalesLogRow
		}
		totals {
			...SalesLogTotal
		}
	}
	${SalesLogRowFragment}
	${SalesLogTotalFragment}
`;

export { CancellationsFragment, SalesLogFragment };
